import { render, staticRenderFns } from "./CourseReviewList.vue?vue&type=template&id=70d76216&scoped=true&"
import script from "./CourseReviewList.vue?vue&type=script&lang=js&"
export * from "./CourseReviewList.vue?vue&type=script&lang=js&"
import style0 from "./CourseReviewList.vue?vue&type=style&index=0&id=70d76216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d76216",
  null
  
)

export default component.exports